export default __webpack_public_path__ + "static/media/file5.22bb08dd.jpg";